module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSLlm77lsYJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMzJweCIgaGVpZ2h0PSIxMzJweCIgdmlld0JveD0iMCAwIDE2IDE2IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAxNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cjxwb2x5Z29uIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNzc3ODdCIiBwb2ludHM9IjEzLjU5MywzLjU0OSA4LjAyOCw4Ljk3NyAyLjQwNywzLjU0OSAxLDQuOTU2ICYjMTA7JiM5OzguMDM1LDExLjc1IDE1LDQuOTU2ICIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/downward-icon.svg
// module id = 320
// module chunks = 0